(function(){
  /* BAE Watch opening film v13 — one continuous thought, ~22 s on its own clock (ms below).
     1 street "You have a feeling." -> push into the dark coat -> 2 that dark is the phone's glass; it wakes; a notification
     -> the map opens in the screen and the screen becomes the frame -> 3 route + pin -> pull back: the map's lines become
     Nashville's lights, the pin settles on the Capitol -> 4 "WE FIND / THE FACTS." -> the city breathes -> black -> logo. */
  var film=document.querySelector('[data-film]'); if(!film) return;
  var $=function(s){return film.querySelector(s);};
  var root=document.documentElement;
  var L={}; [].forEach.call(film.querySelectorAll('[data-l]'),function(el){L[el.getAttribute('data-l')]=el;});
  var phone=$('[data-phone]'), screen=$('[data-screen]'), lock=$('[data-ui="lock"]'), mapui=$('[data-ui="map"]'), note=$('[data-note]'), dot=note.querySelector('b');
  var cvP=$('[data-cv-phone]'), cvF=$('[data-cv-full]'), pin=$('[data-pin]'), osm=$('[data-osm]'), cam=$('[data-cam]');
  var q=$('[data-q]'), a=$('[data-a]'), scrim=$('[data-scrim]'), black=$('[data-black]'), logo=$('[data-logo]'), snd=$('[data-sound]');
  var vWalk=L.walk.querySelector('video'), vCity=L.city.querySelector('video');
  var reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
  [vWalk,vCity].forEach(function(v){ if(v){ v.muted=true; v.setAttribute('muted',''); } });
  film.classList.add('is-ready');
  if(reduce){ film.classList.add('is-still'); op(L.walk,1); return; }

  /* ---- the map: real street geometry (OpenStreetMap) ---- */
  var MAP=null, PATHS=null, A=[0.4148,0.6667], S=null;
  function toPath(list,close){var P=new Path2D();list.forEach(function(a){for(var i=0;i<a.length;i+=2){var x=a[i]/1e4,y=a[i+1]/1e4;if(i===0)P.moveTo(x,y);else P.lineTo(x,y);}if(close)P.closePath();});return P;}
  var mapUrl=film.getAttribute('data-map');
  if(mapUrl) fetch(mapUrl).then(function(r){return r.json();}).then(function(j){MAP=j;PATHS={water:toPath(j.water||[],1),river:toPath(j.river||[]),minor:toPath(j.minor||[]),major:toPath(j.major||[]),hwy:toPath(j.hwy||[]),park:toPath(j.park||[],1)};A=j.pinA||A;}).catch(function(){});
  function drawMap(cv,s,reveal,route,bg,lines){
    var d=Math.min(2,window.devicePixelRatio||1),W=cv.clientWidth,H=cv.clientHeight; if(!W||!H) return;
    if(cv.width!==Math.round(W*d)||cv.height!==Math.round(H*d)){cv.width=Math.round(W*d);cv.height=Math.round(H*d);}
    var c=cv.getContext('2d'); c.setTransform(d,0,0,d,0,0); c.globalAlpha=1; c.clearRect(0,0,W,H);
    if(bg>0){ c.globalAlpha=bg; c.fillStyle='#07080c'; c.fillRect(0,0,W,H); }
    if(PATHS){
      var u=1/s; c.globalAlpha=reveal*lines; c.setTransform(d*s,0,0,d*s,d*(W/2-A[0]*s),d*(H/2-A[1]*s));
      if(bg>0.05){ c.globalAlpha=reveal*lines*bg; c.fillStyle='#0b1220'; c.fill(PATHS.water); c.fillStyle='#0b0f0d'; c.fill(PATHS.park); c.globalAlpha=reveal*lines; }
      c.lineCap='round'; c.lineJoin='round';
      c.strokeStyle='#0d1626'; c.lineWidth=Math.max(6*u,0.004); c.stroke(PATHS.river);
      c.strokeStyle='rgba(225,214,206,.085)'; c.lineWidth=0.7*u; c.stroke(PATHS.minor);
      c.strokeStyle='rgba(235,222,214,.2)'; c.lineWidth=1.2*u; c.stroke(PATHS.major);
      c.strokeStyle='rgba(255,128,168,.24)'; c.lineWidth=1.9*u; c.stroke(PATHS.hwy);
      if(MAP && MAP.labels && s>W*1.2){ c.setTransform(d,0,0,d,0,0); c.font='500 9px '+getComputedStyle(film).getPropertyValue('--body'); c.fillStyle='rgba(244,237,230,'+(0.28*lines).toFixed(3)+')'; c.textAlign='center';
        MAP.labels.forEach(function(l){var x=W/2+(l[1]-A[0])*s,y=H/2+(l[2]-A[1])*s; if(x>-80&&x<W+80&&y>-20&&y<H+20){c.save();c.translate(x,y);c.rotate(l[3]||0);c.fillText(l[0].toUpperCase().split('').join(String.fromCharCode(8202)),0,0);c.restore();}}); }
    }
    if(route>0 && S){ c.setTransform(d,0,0,d,0,0); c.globalAlpha=lines;
      var ax=W/2+(S[0]-A[0])*s, ay=H/2+(S[1]-A[1])*s, bx=W/2, by=H/2;
      var mx=(ax+bx)/2+(by-ay)*0.22, my=(ay+by)/2-(bx-ax)*0.22;
      var len=Math.hypot(bx-ax,by-ay)*1.15+1;
      c.beginPath(); c.moveTo(ax,ay); c.quadraticCurveTo(mx,my,bx,by);
      c.setLineDash([len*route,len*2]); c.lineCap='round'; c.strokeStyle='rgba(255,46,110,.92)'; c.lineWidth=1.6;
      c.stroke(); c.setLineDash([]); }
  }

  var E=function(t){return t<.5?4*t*t*t:1-Math.pow(-2*t+2,3)/2;};
  var S2=function(t){return t*t*(3-2*t);};
  var O=function(t){return 1-Math.pow(1-t,3);};
  var IN=function(t){return t*t*t;};
  var LIN=function(t){return t;};
  var cl=function(v){return v<0?0:v>1?1:v;};
  function seg(t,a,b,ease){return (ease||S2)(cl((t-a)/(b-a)));}
  function op(el,v){ if(!el) return; el.style.opacity=v<.002?0:v.toFixed(3); el.style.visibility=v<.002?'hidden':'visible'; }
  function mix(a,b,k){return a+(b-a)*k;}

  var vw=innerWidth, vh=innerHeight, sw=1, cover=4, fr=film.getBoundingClientRect();
  function measure(){ vw=innerWidth; vh=innerHeight; sw=screen.offsetWidth||1; cover=Math.max(vw/sw, vh/(screen.offsetHeight||1))*1.06; fr=film.getBoundingClientRect(); }

  /* where the Capitol sits on screen in the city shot (object-fit:cover, object-position 57% 58%) */
  var CAP=[0.575,0.6];
  function capitol(scale){ var W=fr.width,H=fr.height, iw=1920, ih=1080, k=Math.max(W/iw,H/ih), dw=iw*k, dh=ih*k;
    var ox=(W-dw)*0.57, oy=(H-dh)*0.58, x=ox+CAP[0]*dw, y=oy+CAP[1]*dh;
    return [W/2+(x-W/2)*scale, H/2+(y-H/2)*scale]; }

  var CITY_START=3.0;
  var clock=0, prev=0, inView=true, ended=false, handed=false, cancelOut=false, cityStarted=false;
  var END=22000, GLIDE=1500;
  function readScroll(){ var r=film.getBoundingClientRect(); inView=r.bottom>0 && r.top<vh; root.classList.toggle('bwf-on', r.bottom>vh*0.35 && !ended); if(r.bottom<vh*0.2) audioOff(); }
  ['wheel','touchstart','keydown','mousedown'].forEach(function(e){addEventListener(e,function(ev){ if(snd&&snd.contains(ev.target)) return; cancelOut=true; [vWalk,vCity].forEach(function(v){if(v)v._blocked=false;});},{passive:true});});
  function play(v,rate){ if(!v || v._blocked) return; if(rate&&v.playbackRate!==rate) v.playbackRate=rate; if(!v.paused) return; var p=v.play(); if(p&&p.catch) p.catch(function(){v._blocked=true;}); }
  function stop(v){ if(v && !v.paused) v.pause(); }
  function handOver(){
    handed=true; ended=true; cancelOut=false; readScroll();
    var next=film.nextElementSibling; if(!next) return;
    var y0=scrollY; if(y0>film.offsetHeight*0.15) return;
    var y1=next.getBoundingClientRect().top+y0, t0=null;
    function step(t){ if(cancelOut) return; if(t0===null) t0=t; var k=cl((t-t0)/GLIDE);
      scrollTo({top:y0+(y1-y0)*E(k),left:0,behavior:'instant'}); if(k<1) requestAnimationFrame(step); }
    requestAnimationFrame(step);
  }

  /* ---- sound: synthesised here, only after a tap ---- */
  var AC=null, G={}, on=false, fired={};
  function noise(ctx,sec){ var b=ctx.createBuffer(2,ctx.sampleRate*sec,ctx.sampleRate); for(var ch=0;ch<2;ch++){var d=b.getChannelData(ch); for(var i=0;i<d.length;i++) d[i]=Math.random()*2-1;} var s=ctx.createBufferSource(); s.buffer=b; s.loop=true; return s; }
  function bus(ctx,dest,gain){ var g=ctx.createGain(); g.gain.value=gain||0; g.connect(dest); return g; }
  function osc(ctx,f,dest,type){ var o=ctx.createOscillator(); o.type=type||'sine'; o.frequency.value=f; o.connect(dest); o.start(); return o; }
  function buildAudio(){
    var C=window.AudioContext||window.webkitAudioContext; if(!C) return null; var ctx=new C();
    var master=bus(ctx,ctx.destination,0.0); G.master=master;
    var comp=ctx.createDynamicsCompressor(); comp.threshold.value=-18; comp.ratio.value=3; comp.connect(master);
    /* street: rain/traffic hiss */
    var n1=noise(ctx,4), f1=ctx.createBiquadFilter(); f1.type='bandpass'; f1.frequency.value=3200; f1.Q.value=0.5; n1.connect(f1); G.street=bus(ctx,comp,0); f1.connect(G.street); n1.start(); G.streetF=f1;
    /* room: the hush around the phone */
    var n2=noise(ctx,4), f2=ctx.createBiquadFilter(); f2.type='lowpass'; f2.frequency.value=260; n2.connect(f2); G.room=bus(ctx,comp,0); f2.connect(G.room); n2.start();
    /* tension: A + E + C (unresolved), C lifts to C# on the answer */
    G.low=bus(ctx,comp,0); var lp=ctx.createBiquadFilter(); lp.type='lowpass'; lp.frequency.value=700; lp.connect(G.low);
    osc(ctx,55,lp); osc(ctx,82.41,lp); G.third=osc(ctx,130.81,lp);
    /* the answer: A major, airy */
    G.pad=bus(ctx,comp,0); var lp2=ctx.createBiquadFilter(); lp2.type='lowpass'; lp2.frequency.value=2200; lp2.connect(G.pad);
    [110,164.81,220,277.18,329.63].forEach(function(f,i){ var o=osc(ctx,f,lp2,'triangle'); o.detune.value=(i%2?4:-4); });
    /* the city: air */
    var n3=noise(ctx,4), f3=ctx.createBiquadFilter(); f3.type='highpass'; f3.frequency.value=4500; n3.connect(f3); G.air=bus(ctx,comp,0); f3.connect(G.air); n3.start();
    G.comp=comp; return ctx;
  }
  function one(f,amp,dec,at){ if(!AC) return; var t0=AC.currentTime+(at||0); var g=AC.createGain(); g.gain.setValueAtTime(0.0001,t0); g.gain.exponentialRampToValueAtTime(amp,t0+0.02); g.gain.exponentialRampToValueAtTime(0.0001,t0+dec); g.connect(G.comp);
    (Array.isArray(f)?f:[f]).forEach(function(fr2,i){ var o=AC.createOscillator(); o.frequency.value=fr2; o.connect(g); o.start(t0); o.stop(t0+dec+0.1); }); }
  function setG(node,v){ if(node) node.gain.setTargetAtTime(v,AC.currentTime,0.12); }
  function audioOff(){ if(on){ on=false; if(AC) G.master.gain.setTargetAtTime(0,AC.currentTime,0.15); syncSound(); } }
  function syncSound(){ if(!snd) return; snd.setAttribute('aria-pressed',on?'true':'false'); snd.querySelector('[data-sound-label]').textContent=on?'Sound off':'Sound on'; snd.classList.toggle('is-on',on); }
  if(snd) snd.addEventListener('click',function(){
    if(!on){ if(!AC) AC=buildAudio(); if(!AC){ snd.hidden=true; return; } if(AC.state==='suspended') AC.resume(); on=true; G.master.gain.setTargetAtTime(0.9,AC.currentTime,0.25); }
    else audioOff();
    syncSound(); });
  function sound(t){
    if(!AC||!on) return;
    var db=function(x){return Math.pow(10,x/20);};
    setG(G.street, db(-24)*seg(t,0,900)*(1-seg(t,3600,4700)));
    setG(G.room,   db(-30)*seg(t,3800,4800)*(1-seg(t,10400,12000)));
    setG(G.low,    db(-26)*seg(t,600,4000)*(1-seg(t,16600,18600)));
    G.third.frequency.setTargetAtTime(t>=11000?138.59:130.81,AC.currentTime,0.6);
    setG(G.pad,    db(-30)*seg(t,11000,13200)*(1-seg(t,16400,18600)));
    setG(G.air,    db(-44)*seg(t,11200,13000)*(1-seg(t,16600,18400)));
    [[5600,function(){one([1318.5,1975.5],0.05,0.9);}],[9100,function(){one([82.4,110],0.22,1.4);}],[18800,function(){one([55,110,164.81],0.3,4.5);}]].forEach(function(ev){
      if(t>=ev[0] && t<ev[0]+300 && !fired[ev[0]]){ fired[ev[0]]=1; ev[1](); } });
  }

  function render(t){
    var W=fr.width, H=fr.height;
    /* 1 · 0-4.4 s  the question. Slow push into the dark coat ahead of us, which becomes black */
    var push=seg(t,0,4300,LIN), dive=seg(t,2900,4400,IN);
    L.walk.style.transform='scale('+(1.02+0.08*push+2.4*dive).toFixed(4)+')';
    op(L.walk, seg(t,0,1100)*(1-seg(t,4250,4500)));
    if(t<4500) play(vWalk,0.8); else stop(vWalk);
    op(L.iris, seg(t,3950,4350)*(1-seg(t,4400,5200)));                 /* the coat's black fills the frame, then lets the phone through */
    var qIn=seg(t,800,2600), qOut=seg(t,3300,4100);
    op(q,(qIn*(1-qOut))); q.style.transform='translate3d(0,'+((1-qIn)*10).toFixed(1)+'px,0) scale('+(1+0.03*push).toFixed(4)+')';
    q.style.filter=(qOut>0.01||qIn<0.99)?'blur('+((1-qIn)*6+qOut*5).toFixed(2)+'px)':'none';

    /* 2 · 4.3-8.4 s  the clue. The phone's dark glass; it wakes; a notification. The map opens; we keep pushing in */
    op(L.desk, seg(t,4200,4500)*(1-seg(t,8300,8450)));
    var zin=seg(t,4300,6900,LIN), z=seg(t,7100,8450,E);
    var sc=(0.9+0.1*zin)*(1+(cover-1)*Math.pow(z,2.2));
    phone.style.transform='translate(-50%,-50%) scale('+sc.toFixed(4)+')';
    var wake=seg(t,4700,5300);
    screen.style.filter=wake<0.999?'brightness('+(0.15+0.85*wake).toFixed(3)+')':'';
    lock.classList.toggle('is-on', t>=4700 && t<7050);
    var n=seg(t,5600,5900,O), hi=seg(t,6500,6800)*(1-seg(t,6950,7100));
    note.style.opacity=(n*(1-seg(t,6950,7150))).toFixed(3);
    note.style.transform='translate3d(0,'+(-10*(1-n)).toFixed(1)+'px,0) scale('+(1+0.05*hi).toFixed(3)+')';
    note.style.boxShadow=hi>0.01?'inset 0 0 0 1px rgba(255,46,110,'+(0.55*hi).toFixed(2)+'),0 10px 30px rgba(0,0,0,.45)':'';
    note.classList.toggle('is-ping', t>=5600);
    if(!S && t>=6950){ var sr=screen.getBoundingClientRect(), dd=dot.getBoundingClientRect(), k=sr.width/sw;
      var sP0=sw/0.30; S=[A[0]+((dd.left+dd.width/2)-(sr.left+sr.width/2))/k/sP0, A[1]+((dd.top+dd.height/2)-(sr.top+sr.height/2))/k/sP0]; }
    mapui.classList.toggle('is-on', t>=6950);
    var reveal=seg(t,6950,7400), route=seg(t,7100,9000,E);
    var sP=(sw/0.30)*(1+0.2*seg(t,7000,8450));
    if(t>=6900 && t<7100) drawMap(cvP,sP,reveal,route,1,1);

    /* 3 · 8.4-11.6 s  the location. Same map, full frame; the pin drops */
    var back=seg(t,10400,12200,E);                                     /* pull back: map gives way to the city */
    var sFull=(t<8450)? sP*sc : (sw/0.30)*1.2*cover*(1+0.12*seg(t,8450,10400,LIN))*(1-0.55*back);
    op(L.map, seg(t,6950,7050)*(1-seg(t,11000,12300)));
    if(t>=6950 && t<8450){ var r=screen.getBoundingClientRect(), rad=(parseFloat(getComputedStyle(screen).borderTopLeftRadius)||0)*(r.width/sw);
      L.map.style.clipPath='inset('+(r.top-fr.top).toFixed(1)+'px '+(fr.right-r.right).toFixed(1)+'px '+(fr.bottom-r.bottom).toFixed(1)+'px '+(r.left-fr.left).toFixed(1)+'px round '+rad.toFixed(1)+'px)'; }
    else L.map.style.clipPath='';
    if(t>=6950 && t<12400) drawMap(cvF,sFull,reveal,route,1-seg(t,10500,11900),1-seg(t,11200,12300));
    osm.classList.toggle('is-on', t>=6950 && t<12000);
    var pd=seg(t,9000,9350,O), pv=seg(t,11400,12600);
    var cp=capitol(mix(1.22,1.0,seg(t,10400,13200,O)));
    var px=mix(W/2,cp[0],back), py=mix(H/2,cp[1],back);
    op(pin, pd*(1-pv));
    pin.style.left=px.toFixed(1)+'px'; pin.style.top=py.toFixed(1)+'px';
    pin.style.transform='translate(-50%,-100%) translate3d(0,'+(-22*(1-pd)).toFixed(1)+'px,0) scale('+(1-0.55*back).toFixed(3)+')';
    pin.classList.toggle('is-down', t>=9330);

    /* 4 · 10.4-18.6 s  the answer. Nashville from above; the title; the city breathes; black */
    if(t>=10200 && !cityStarted){ cityStarted=true; if(vCity){ try{vCity.currentTime=CITY_START;}catch(e){} } }
    if(cityStarted && t<18800) play(vCity,0.85); else stop(vCity);
    op(L.city, seg(t,10400,11800));
    L.city.style.transform='scale('+mix(1.22,1.0,seg(t,10400,13200,O)).toFixed(4)+')';
    var aIn=seg(t,11300,13300), aOut=seg(t,15400,16800), aPush=seg(t,11300,16800,LIN);
    op(a, aIn*(1-aOut));
    a.style.transform='scale('+(1.03-0.03*aIn+0.02*aPush).toFixed(4)+')';
    a.style.letterSpacing=(0.015+0.05*(1-aIn)).toFixed(4)+'em';
    a.style.filter=(aIn<0.995||aOut>0.005)?'blur('+((1-aIn)*12+aOut*8).toFixed(2)+'px)':'none';
    op(scrim, cl(seg(t,600,2400)*0.3-seg(t,3600,4400)*0.3+seg(t,11000,12800)*0.36-seg(t,15600,17000)*0.36));
    op(black, seg(t,16600,18500));
    var m=seg(t,18800,20200);
    op(logo,m); logo.style.transform='scale('+(0.99+0.01*m).toFixed(4)+')';
    if(snd){ var so=seg(t,1800,2800)*(1-seg(t,20800,21600)); snd.style.opacity=(so*0.78).toFixed(3); snd.style.visibility=so<.01?'hidden':'visible'; }
    cam.style.transform='translate3d('+(Math.sin(t/1700)*2.5).toFixed(1)+'px,'+(Math.cos(t/2300)*1.8).toFixed(1)+'px,0)';
    sound(t);
  }

  function frame(now){
    var dt=prev?Math.min(100,now-prev):0; prev=now;
    if(inView && !document.hidden) clock+=dt;
    render(Math.min(clock,END+400));
    if(!handed && clock>=END) handOver();
    if(clock<END+400) requestAnimationFrame(frame); else audioOff();
  }
  addEventListener('scroll',readScroll,{passive:true});
  addEventListener('resize',function(){measure();readScroll();});
  addEventListener('load',measure);
  measure(); readScroll(); render(0); syncSound();
  requestAnimationFrame(frame);
})();
